import React from 'react'
import { Router } from '@reach/router'
import { withApollo } from 'react-apollo'
import { SEO } from '../components/SEO/seo'
import { PreviewPageComponent } from '../components/preview'

const pageTypes = ['page', 'landingpage']

function Client () {
  const dateStamp = new Date().toISOString().split('T')[0]

  return (
    <React.Fragment>
      <SEO createdAt={dateStamp} updatedAt={dateStamp}
        meta={[
          {
            name: 'robots',
            content: 'noindex, nofollow'
          }
        ]}
      />
      <Router>
        {pageTypes.map(pageType => <PreviewPageComponent key={pageType} path={`/client/preview/${pageType}`} pageType={pageType} />)}
      </Router>
    </React.Fragment>
  )
}

export default withApollo(Client)
